<div class="fullcontainer pr-3">
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color:#006598;'>Sage 50 Export Batches</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/invoices/sage-export'>
        <i class="fas fa-file-export"></i> Build a Batch
      </button>&nbsp;
      <button class='btn btn-secondary' routerLink='/invoices/sage-export/tax-codes'>
        <i class="fas fa-percent"></i> Sage Tax Codes
      </button>
    </div>
  </div>
  <br />

  @if (this.isError) {
    <div class='alert alert-danger'>Could not load the batches. Please try again later.</div>
  }

  <div class='sheet'>
    <p class='text-muted'>
      Every batch that has been built. A batch is only in Sage once somebody has run the import
      and recorded what Sage accepted &mdash; anything outstanding returns in the next batch.
    </p>

    <div class='form-row'>
      <div class='form-group col-md-3'>
        <label for='state'>Show</label>
        <select id='state' class='form-control' (change)='this.onStateChanged($event.target.value)'>
          <option value='all'>All batches</option>
          <option value='outstanding'>Outstanding only</option>
          <option value='confirmed'>Fully confirmed only</option>
        </select>
      </div>
    </div>
  </div>

  @if (this.hasLoaded && this.isEmpty) {
    <div class='sheet'>
      <p class='m-0'>No Sage batches have been built yet.</p>
      <br />
      <button class='btn btn-primary' routerLink='/invoices/sage-export'>Build the first batch</button>
    </div>
  }

  <!-- Kept in the DOM when empty rather than swapped out: the grid owns the fetch, so removing it
       would mean the state filter had nothing to re-read through. -->
  <app-grid
    entity='sage-export-batch'
    [columns]='this.columns'
    [buttons]='this.buttons'
    [customDataSource]='this.getRecords.bind(this)'
    [showSearch]='false'
  ></app-grid>
</div>
